import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="container" style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Informativa sulla Privacy</h1>
      <p>Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>
      
      <p>La presente Informativa sulla Privacy descrive come Consulentecrediti S.r.l.s. raccoglie, utilizza e protegge i dati personali degli utenti del sito verificaincentivi.it, in conformità con il Regolamento (UE) 2016/679 (GDPR) e la normativa italiana vigente.</p>

      <h2>1. Titolare del Trattamento</h2>
      <p>Il Titolare del trattamento dei dati è:<br />
      <strong>Consulentecrediti S.r.l.s.</strong><br />
      P.IVA: 06139990870<br />
      Sede: Via Ravanusa N.13, 95030 Tremestieri Etneo (CT)<br />
      Email: <a href="mailto:info@verificaincentivi.it">info@verificaincentivi.it</a><br />
      PEC: <a href="mailto:consulentecrediti@legalmail.it">consulentecrediti@legalmail.it</a></p>

      <h2>2. Dati Raccolti</h2>
      <p>Raccogliamo le seguenti categorie di dati personali:</p>
      <ul>
        <li><strong>Dati anagrafici e di contatto:</strong> nome, cognome, email, numero di telefono.</li>
        <li><strong>Dati aziendali:</strong> ragione sociale, partita IVA, settore di attività, dati di bilancio, visure camerali.</li>
        <li><strong>Dati di navigazione:</strong> indirizzi IP, tipo di browser, pagine visitate, log di sistema.</li>
      </ul>

      <h2>3. Finalità del Trattamento</h2>
      <p>I dati personali sono trattati per le seguenti finalità:</p>
      <ul>
        <li>Erogazione del servizio di analisi e generazione dei report sugli incentivi.</li>
        <li>Gestione dell'account utente e assistenza clienti.</li>
        <li>Adempimento di obblighi legali, contabili e fiscali.</li>
        <li>Invio di comunicazioni commerciali e newsletter (solo previo consenso esplicito).</li>
      </ul>

      <h2>4. Base Giuridica del Trattamento</h2>
      <p>Il trattamento dei dati si basa su:</p>
      <ul>
        <li>Esecuzione di un contratto o misure precontrattuali (per l'erogazione del servizio).</li>
        <li>Consenso dell'interessato (per finalità di marketing).</li>
        <li>Legittimo interesse del Titolare (per la sicurezza del sito e prevenzione frodi).</li>
        <li>Obbligo di legge.</li>
      </ul>

      <h2>5. Conservazione dei Dati</h2>
      <p>I dati personali saranno conservati per il tempo strettamente necessario a conseguire gli scopi per cui sono stati raccolti, e comunque non oltre i termini previsti dalla legge per la conservazione di documenti contabili e fiscali (10 anni).</p>

      <h2>6. Condivisione dei Dati</h2>
      <p>I dati potranno essere condivisi con:</p>
      <ul>
        <li>Fornitori di servizi IT e hosting (es. servizi cloud).</li>
        <li>Consulenti esterni (es. commercialisti, legali) vincolati da obblighi di riservatezza.</li>
        <li>Autorità competenti, se richiesto dalla legge.</li>
      </ul>

      <h2>7. Diritti dell'Interessato</h2>
      <p>Ai sensi degli artt. 15-22 del GDPR, l'utente ha il diritto di:</p>
      <ul>
        <li>Accedere ai propri dati personali.</li>
        <li>Richiedere la rettifica o la cancellazione degli stessi.</li>
        <li>Limitare o opporsi al trattamento.</li>
        <li>Richiedere la portabilità dei dati.</li>
        <li>Revocare il consenso in qualsiasi momento.</li>
        <li>Proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali.</li>
      </ul>

      <h2>8. Modalità di Esercizio dei Diritti</h2>
      <p>Per esercitare i propri diritti, l'utente può inviare una comunicazione scritta all'indirizzo email <a href="mailto:info@verificaincentivi.it">info@verificaincentivi.it</a> o tramite PEC a <a href="mailto:consulentecrediti@legalmail.it">consulentecrediti@legalmail.it</a>.</p>
    </div>
  );
}
